<template>
    <div class="modal-backdrop" @click.self="$emit('close')">
        <div class="modal-content folder-assign-modal">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('add_to_folder') }}</h5>
                <button type="button" class="close" @click="$emit('close')">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="text-muted">{{ $t('select_folders', { count: invoiceIds.length }) }}</p>
                <div v-if="allFolders.length === 0" class="text-center py-3">
                    <small class="text-muted">{{ $t('no_folders_create') }}</small>
                </div>
                <div v-for="folder in rootFolders" :key="folder.id">
                    <FolderCheckItem
                        :folder="folder"
                        :all-folders="allFolders"
                        :selected="selectedFolderIds"
                        @toggle="toggleFolder"
                    />
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-sm btn-secondary" @click="$emit('close')">{{ $t('cancel') }}</button>
                <button class="btn btn-sm btn-primary" @click="assignToFolders" :disabled="selectedFolderIds.length === 0">
                    {{ $t('add_to_folders', { count: selectedFolderIds.length }) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Folder from '@/store/models/folder';
import Invoice from '@/store/models/invoice';
import FolderCheckItem from './FolderCheckItem';


export default {
    name: 'FolderAssignModal',
    i18nOptions: { namespaces: 'folders' },
    components: { FolderCheckItem },
    props: {
        invoiceIds: { type: Array, required: true },
    },
    data() {
        return {
            selectedFolderIds: [],
        };
    },
    computed: {
        allFolders() {
            return Folder.query().where('$isNew', false).get();
        },
        rootFolders() {
            return this.allFolders.filter(f => !f.parent_id);
        },
    },
    methods: {
        toggleFolder(folderId) {
            const idx = this.selectedFolderIds.indexOf(folderId);
            if (idx >= 0) {
                this.selectedFolderIds.splice(idx, 1);
            } else {
                this.selectedFolderIds.push(folderId);
            }
        },
        async assignToFolders() {
            for (const invoiceId of this.invoiceIds) {
                const invoice = Invoice.find(invoiceId);
                if (!invoice) continue;
                const existingIds = invoice.folder_ids || [];
                const merged = [...new Set([...existingIds, ...this.selectedFolderIds])];
                await this.$store.dispatch('invoices/updateInvoice', {
                    invoiceId,
                    props: { folder_ids: merged },
                });
            }
            this.$emit('assigned');
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}
.folder-assign-modal {
    background: #fff;
    border-radius: 8px;
    width: 400px;
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    .modal-body {
        overflow-y: auto;
    }
}
</style>
